const checkLanguageVersion = (locale, languages) => {
  if (!!!languages) return true;
  if (languages.includes(locale)) return true;
  return false;
};

module.exports = {
  checkLanguageVersion,
};
